import classes from './Omne.module.css'
import profilePhotoWebp from './../../img/profile-v2.webp'; 
import profilePhotoPng from './../../img/profile-v2.png'; 

const Omne = () => {
    return ( 
        <div className = {classes.Omne} id="Omne">
            <div className = {classes.content}>
                <h1>Dobrý deň!</h1>
                <div  className = {classes.podNadpisom} >
                    <div className = {classes.podNadpisomVlavo} >
                        <p>Moje meno je Lucia Hlístová a poskytujem <span style={{fontWeight: 'bold', fontFamily:"inherit"}}>poradenské, konzultačné a koučingové služby</span>.<br/>
                        Mám za sebou niekoľko rokov práce s obeťami násilia všetkých druhov a venujem sa aj práci s ľuďmi v krízových situáciách. Zároveň sa profesionálne venujem aj koučingu.<br/>
                        Mojím cieľom je vytvoriť <span style={{fontWeight: 'bold', fontFamily:"inherit"}}>bezpečný a podporný</span> priestor, kde sa môžete <span style={{fontWeight: 'bold', fontFamily:"inherit"}}>zastaviť, zorientovať</span> sa vo svojich možnostiach a urobiť krok k <span style={{fontWeight: 'bold', fontFamily:"inherit"}}>zmenám</span>, ktoré sú pre Vás dôležité.<br />
                        Rada tu budem pre Vás. Na to, aby sme si mohli dohodnúť termín, stačia <span style={{fontWeight: 'bold', fontFamily:"inherit"}}>štyri jednoduché kroky:</span></p>
                        <ol>
                            <li><p style={{display:"inline"}}>Zoberte si mobil</p></li>
                            <li><p style={{display:"inline"}}>Zatelefonujte na tel. číslo: +421 949 650 049 / napíšte email na: lanavihlistova@gmail.com</p></li>
                            <li><p style={{display:"inline"}}>Dohodnite si so mnou konkrétny termín</p></li>
                            <li><p style={{display:"inline"}}>Prídite :)</p></li>
                        </ol>
                    </div>
                    <picture>
                        <source type="image/avif" srcSet={profilePhotoWebp} />
                        <source type="image/png" srcSet={profilePhotoPng} />
                        <img src={profilePhotoPng} alt="Logo" />
                    </picture>
                </div>
            </div>
        </div> 
    );
}
 
export default Omne;